import * as React from 'react';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  useTheme,
  Theme,
  MuiThemeProvider
} from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import './CSSearchFilter.scss';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';
import iObjCSService from 'src/services/claimStatus/claimStatusService';
// });
export const SEARCH_FILTER_MAPPING = {
  'Claim No': 'Claim Number',
  'Narda No': 'Narda Number',
  'Order No': 'Order Number',
  'Purchase Order No': 'Purchase Order Number'
};
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    chip: {
      margin: 2
    },
    noLabel: {
      marginTop: theme.spacing(3)
    }
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 'auto'
    }
  }
};
/*
const names = [
  { text: `${i18n.t('CSFilters.ClaimNumber')}`, val: 'Claim Number' },
  {
    text: `${i18n.t('CSFilters.OriInvNumber')}`,
    val: 'Original Invoice Number'
  },
  { text: `${i18n.t('CSFilters.CrInvNumber')}`, val: 'Credit Invoice Number' },
  { text: `${i18n.t('CSFilters.CSPartNumber')}`, val: 'Part Number' },
  { text: `${i18n.t('CSFilters.UrRefNumber')}`, val: 'Your Reference Number' },
  { text: `${i18n.t('CSFilters.OriPONumber')}`, val: 'Original PO Number' }
  // 'Invoice No', 'Narda No', 'Order No', 'Purchase Order No'
];
*/
export default function CSSearchFilter(props: any) {
  const names = [
    {
      claimSearchOption: `${i18n.t('CSFilters.ClaimNumber')}`,
      val: 'Claim Number'
    },
    {
      claimSearchOption: `${i18n.t('CSFilters.OriInvNumber')}`,
      val: 'Original Invoice Number'
    },
    {
      claimSearchOption: `${i18n.t('CSFilters.CrInvNumber')}`,
      val: 'Credit Invoice Number'
    },
    {
      claimSearchOption: `${i18n.t('CSFilters.CSPartNumber')}`,
      val: 'Part Number'
    },
    {
      claimSearchOption: `${i18n.t('CSFilters.UrRefNumber')}`,
      val: 'Your Reference Number'
    },
    {
      claimSearchOption: `${i18n.t('CSFilters.OriPONumber')}`,
      val: 'Original PO Number'
    }
    // 'Invoice No', 'Narda No', 'Order No', 'Purchase Order No'
  ];

  const classes = useStyles();
  const theme = useTheme();
  const [csSearchKeys, setCSSearchKeys] = React.useState([]);
  const [personName, setPersonName] = React.useState<string[]>([
    'Claim Number'
  ]);
  const { isReset, isResetSearch } = props;
  const [apiLoader, handleApiLoader] = React.useState(false);
  React.useEffect(() => {
    if (csSearchKeys.length === 0) {
      handleApiLoader(true);
      iObjCSService
        .gCSSearchKeysLookupData()
        .then((response: any) => {
          // console.log(response);
          const resData = response;
          setCSSearchKeys(resData);
        })
        .catch((error: any) => {
          handleApiLoader(false);
          setCSSearchKeys([]);
        });
    }
  }, []);

  React.useEffect(() => {
    if (isReset || isResetSearch) {
      // console.log('Reset Initiated');
      setPersonName(['Claim Number']);
    }
  }, [isReset, isResetSearch]);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    // console.log(event.target.value + 'handle change');
    setPersonName(event.target.value as string[]);

    let searchValue: any = event.target.value;
    let searchKey: any = searchValue;
    // console.log(searchKey);
    // console.log(searchValue);
    props.setFilters(searchKey);
    searchValue = null;
    searchKey = null;
  };
  const { getInvoices } = props;
  const gCSSearchOptionMenuItem = (val: any, index: number) => {
    return (
      <MenuItem
        key={index}
        value={val.claimSearchOption}
        className="invoices-dropdown"
      >
        {val.claimSearchOption}
      </MenuItem>
    );
  };
  // props.setFilters(personName);
  return (
    <div className="Invoicefilter-container CSSearchfilter-container col-7 noplr0">
      <MuiThemeProvider theme={theme}>
        <FormControl className={clsx(classes.formControl, classes.noLabel)}>
          <Select
            className="csSearchOptions"
            displayEmpty={true}
            value={personName}
            onChange={handleChange}
            MenuProps={MenuProps}
            inputProps={{ 'aria-label': 'Without label' }}
          >
            {csSearchKeys &&
              csSearchKeys.length > 0 &&
              csSearchKeys.map((val: any, index: number) =>
                gCSSearchOptionMenuItem(val, index)
              )}
            {/* <MenuItem value="">{i18n.t('invoices.searchBy')}</MenuItem> */}
          </Select>
        </FormControl>
      </MuiThemeProvider>
    </div>
  );
}
